import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsx mdx */

import DefaultLayout from "/opt/build/repo/node_modules/gatsby-theme-docz/src/base/Layout.js";
import { Modal, ModalHeader } from "./";
import Sandbox from '@components/Sandbox';
import Playground from '@components/Playground';
export const _frontmatter = {};
const layoutProps = {
  _frontmatter
};
const MDXLayout = DefaultLayout;
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">



    <h1 {...{
      "id": "modal"
    }}>{`Modal`}</h1>
    <p>{`Modal component provides platform for creating dialogs, popovers or whatever else.`}</p>
    <h2 {...{
      "id": "usage"
    }}>{`Usage`}</h2>
    <Sandbox mdxType="Sandbox">
  <Sandbox.Text>
    import {'{ Modal }'} from '@cleartrip/bento'
  </Sandbox.Text>
  <Sandbox.Text>
    <br />
    <br />
    {'<Modal open={false}>'}
      <br />
      {' <ModalHeader onClose={toggleFn} closeButton>Modal header</ModalHeader>'}
      <br />
      {' <div className="px-8">Modal content</div>'}
      <br />
    {'</Modal>'}
  </Sandbox.Text>
    </Sandbox>
    <h2 {...{
      "id": "playground"
    }}>{`Playground`}</h2>
    <Playground __position={1} __code={''} __scope={{
      props,
      DefaultLayout,
      Modal,
      ModalHeader,
      Sandbox,
      Playground,
      DefaultLayout,
      _frontmatter
    }} code="<Modal>...</Modal>" scope={{
      Modal
    }} mdxType="Playground" />

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      